export default{
    lista:{
        method:'get',
        url:'tabelaprecorublica/evento/lista'
    },
    pesquisa:{
        method:'get',
        url:'tabelapreco/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'tabelaprecorublica/evento/cadastro'
    },
    delete:{
        method:'delete',
        url:'tabelaprecorublica/evento/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'tabelaprecorublica/evento/editar{/id}'
    },
    update:{
        method:'post',
        url:'tabelaprecorublica/evento/update'
    },
    configuracaocartaoponto:{
        method:'post',
        url:'tabelapreco/configuracao/cartaoponto'
    },
    mover:{
        method:'post',
        url:'tabelapreco/mover'
    },
    rublica:{
        method:'get',
        url:'tabelaprecorublica/evento/show{/id}'
    },
}